import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import {ClosableDialogTitle} from '@components/dialog/closable-title/ClosableDialogTitle';
import connectToStores from 'alt-utils/lib/connectToStores';
import DepartmentFilterStore from 'stores/DepartmentFilterStore';
import DepartmentFilterActions from 'actions/DepartmentFilterActions';
import './DashboardDeptFilter.styl';
import AdminDepartmentSelect from 'components/dashboard/AdminDepartmentSelect';
import ManagerDepartmentSelect from 'components/dashboard/ManagerDepartmentSelect';
import AuthStore from 'stores/AuthStore';
import Button from '@material-ui/core/Button';
import CogIcon from 'components/pure/utils/icon/CogIcon';
import {Link} from 'react-router';

@connectToStores
export default class DashboardDeptFilter extends React.PureComponent {
  state = {
    showDialog: false,
  };

  static getStores() {
    return [DepartmentFilterStore];
  }

  static getPropsFromStores() {
    const store = DepartmentFilterStore.getState();
    return {
      allDepts: store.allowedDepartments,
      selectedDepts: store.departmentSubset,
      defaultIds: store.defaultIds,
    };
  }

  renderDialog() {
    const {allDepts, selectedDepts} = this.props;
    const isAdmin = AuthStore.getState().user.isAdmin();
    const Select = isAdmin ? AdminDepartmentSelect : ManagerDepartmentSelect;

    return (
      <Dialog
        onClose={() => this.setState({showDialog: false})}
        className="dashboard-dept-filter-modal"
        open={this.state.showDialog}>
        <ClosableDialogTitle onClose={() => this.setState({showDialog: false})}>
          Department Filter
        </ClosableDialogTitle>
        <DialogContent className="dialog-content">
          <Select allDepts={allDepts} selectedDepts={selectedDepts} />
        </DialogContent>
        <DialogActions className="actions">
          <EditDefaultLink />
          <div className="right-actions">
            {isAdmin && (
              <Button
                variant="outlined"
                className="ev-button"
                onClick={DepartmentFilterActions.selectAll}>
                Select All
              </Button>
            )}
            <Button
              variant="outlined"
              className="ev-button"
              onClick={DepartmentFilterActions.resetIds}>
              Reset to Default
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    );
  }

  render() {
    const {allDepts, selectedDepts, defaultIds} = this.props;
    // Don't show if the user doesn't have a set of departments selected from the admin ui
    if (defaultIds.isEmpty()) return null;

    const filterInactive = allDepts.size === selectedDepts.size || selectedDepts.isEmpty();
    const first = allDepts.get(selectedDepts.first());

    return (
      <div className="dashboard-dept-filter">
        <div onClick={() => this.setState({showDialog: true})}>
          <div className="header-widget">
            <span className="filtered-view">Filtered View:</span>
            {filterInactive ? (
              <div className="inactive">All Departments</div>
            ) : (
              <div className="active">
                {selectedDepts.size === 1
                  ? first.name
                  : `${selectedDepts.size} / ${allDepts.size} Selected`}
              </div>
            )}
            {arrowSVG}
          </div>
        </div>
        {this.renderDialog()}
      </div>
    );
  }
}

const arrowSVG = (
  <svg
    className="arrow-svg"
    width="7"
    height="5"
    viewBox="0 0 7 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M1 1L3.5 3.5L6 1" stroke="#A2A1A1" strokeLinecap="round" />
  </svg>
);

function EditDefaultLink() {
  const user = AuthStore.getState().user;
  if (!user.isAdmin()) return <div />;

  return (
    <Button
      component={Link}
      to={{
        pathname: `/admin/users/edit/${user.id}`,
        state: {fromDeptModal: true},
      }}>
      <CogIcon />
      Change default
    </Button>
  );
}
